
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { Label } from '../ui/label';
import { Switch } from '../ui/switch';

import { CategoryKey, DraftPreferences } from './useConsentForm';

const CATEGORIES: { key: CategoryKey; locked?: boolean }[] = [
  { key: 'necessary', locked: true },
  { key: 'preferences' },
  { key: 'analytics' },
  { key: 'marketing' },
];

type Props = {
  draft: DraftPreferences;
  onToggle: (key: Exclude<CategoryKey, 'necessary'>, checked: boolean) => void;
};

const CookieCategoriesGrid = ({ draft, onToggle }: Props) => {
  const intl = useIntl();
  return (
    <div className="space-y-4" data-testid="group-cookie-categories">
      {CATEGORIES.map(({ key, locked = false }) => {
        const checked = draft[key];
        const label = intl.formatMessage({ id: `CookieConsent.category.${key}.label` });
        return (
          <div
            key={key}
            className="flex items-center justify-between gap-4"
            data-testid={`card-cookie-category-${key}`}
          >
            <div className="min-w-0 space-y-0.5">
              <div className="flex items-center gap-2">
                <Label data-testid={`text-cookie-category-title-${key}`}>{label}</Label>
                {locked && (
                  <span
                    className="rounded-full bg-muted px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-muted-foreground"
                    data-testid="status-cookie-necessary-required"
                  >
                    <FormattedMessage id="CookieConsent.alwaysOn" />
                  </span>
                )}
              </div>
              <p
                className="text-sm text-muted-foreground"
                data-testid={`text-cookie-category-description-${key}`}
              >
                <FormattedMessage id={`CookieConsent.category.${key}.description`} />
              </p>
            </div>
            <Switch
              checked={checked}
              disabled={locked}
              onCheckedChange={next => {
                if (!locked) onToggle(key as Exclude<CategoryKey, 'necessary'>, next);
              }}
              className="flex-shrink-0"
              data-testid={`switch-cookie-category-${key}`}
              aria-label={intl.formatMessage({ id: 'CookieConsent.category.aria' }, { label })}
            />
          </div>
        );
      })}
    </div>
  );
};

export default CookieCategoriesGrid;
